export function recordDeviceName(record) {
  for (const value of [
    record?.machineName,
    record?.deviceName,
    record?.deviceId,
  ]) {
    if (value !== null && value !== undefined && String(value).trim())
      return String(value);
  }
  return "-";
}
